/** @file easeAt: the easing curves a key applies toward the next key. */
import type { Ease } from '@zilo/pose3d-format/types/clip';

const CURVES: Readonly<Record<Ease, (t: number) => number>> = {
  linear: (t) => t,
  easeIn: (t) => t * t,
  easeOut: (t) => 1 - (1 - t) * (1 - t),
  easeInOut: (t) => 3 * t * t - 2 * t * t * t,
  step: () => 0,
};

/** Eased progress for `t` in [0, 1]: linear t, easeIn t^2, easeOut 1-(1-t)^2, easeInOut 3t^2-2t^3, step 0. */
export function easeAt(ease: Ease, t: number): number {
  return CURVES[ease](t);
}
